import PressableIcon from '@ui/buttons/PressableIcon'
import Modal, { ModalHeader } from '@ui/components/Modal'
import Glass from '@ui/elements/Glass'
import AnimatedModalPanel from '@ui/animated/AnimatedModalPanel'
import Signature from 'features/signature/Signature'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

const SignatureModal = ({
  open,
  onClose,
  onSave,
  isPending,
}: {
  open: boolean
  onSave: (signature: string) => void
  onClose: () => void
  isPending: boolean
}) => {
  const { t } = useTranslation(['ui'])
  return (
    <Modal enabled={open} onClose={onClose}>
      <AnimatedModalPanel>
        <Glass className="flex flex-col items-center gap-16 px-8 pb-16 pt-16">
          <View className="absolute left-4 top-4">
            <PressableIcon name="x" onPress={onClose} />
          </View>
          <ModalHeader path="signature" ns="modals" />
          <Signature
            onSave={onSave}
            disabled={isPending}
            buttonProps={{
              variant: 'filled',
              label: t('ui:submit'),
              loading: isPending,
              iconEnd: 'arrow-narrow-right',
            }}
          />
        </Glass>
      </AnimatedModalPanel>
    </Modal>
  )
}

export default SignatureModal
